import { ECreditCardBrands, EFundsOperation } from '@enum';
import { TMyLoyalty } from '@xeppt/xeppt-sdk/types/loyalty';
import { ETransactionAction, ETransactionMethod, ETransactionType } from '@xeppt/xeppt-sdk/types';
import { paymentsConfig } from '@const/payment';

export const getCardBrand = (card_number: string) => {
    const cleanedCardNumber = card_number.replace(/\D/g, ''); // Remove all non-digit characters

    if (/^4[0-9]{12}(?:[0-9]{3})?$/.test(cleanedCardNumber)) {
        return ECreditCardBrands.VISA;
    } else if (/^5[1-5][0-9]{14}$/.test(cleanedCardNumber)) {
        return ECreditCardBrands.MASTERCARD;
    } else if (/^3[47][0-9]{13}$/.test(cleanedCardNumber)) {
        return ECreditCardBrands.AMEX;
    } else if (/^6(?:011|5[0-9]{2})[0-9]{12}$/.test(cleanedCardNumber)) {
        return ECreditCardBrands.DISCOVER;
    } else {
        return;
    }
};

export const getFeesPlanSendAndRequest = ({
    loyalty,
    method
}: {
    loyalty?: TMyLoyalty;
    method: EFundsOperation;
}) => {
    const plan = loyalty?.current_plan;
    //@ts-ignore
    if (plan?.[method]) return plan?.[method];
    return undefined;
};

export const getInternalTransferAction = (
    method: ETransactionMethod,
    action: ETransactionAction,
    type: ETransactionType
) => {
    return Object.keys(paymentsConfig).find((key) => {
        //@ts-ignore
        const config = paymentsConfig[key as EFundsOperation];
        return config.action === action && config.method === method && config.type === type;
    }) as EFundsOperation | undefined;
};
